module.exports = __webpack_public_path__ + "img/developer.e10846fa.png";